export const getApiHost = (clientId: string) => `https://${clientId}`
